import { render, staticRenderFns } from "./ConfirmAdmission.vue?vue&type=template&id=0f99c671&"
import script from "./ConfirmAdmission.vue?vue&type=script&lang=js&"
export * from "./ConfirmAdmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports